import { call, put, takeLatest } from 'redux-saga/effects';
import { EXPORT_MESSAGE_ARCHIVE_REQUEST } from './constants';
import { GatewayManagementApi } from 'api';
import { apiCallStatus, NOTIFICATION_TYPES } from 'helpers/constants';
import { notify } from 'sharedComponents/GeneralNotification';
import { translate } from 'helpers/translateHelper';
import { getExportMessageArchiveAction } from './actions';

function* exportMessageArchiveSaga(params) {
    const payload = {
        assetId: params.assetId,
        assetSerialNumber: params.assetSerialNumber,
        beginTime: params.beginTime,
        endTime: params.endTime,
        captureFormat: params.captureFormat,
        dcuId: params.dcuId,
        dcuSerialNumber: params.dcuSerialNumber,
        eventHubOrIoTEventHubEndPointName: params.eventHubOrIoTEventHubEndPointName,
        partitionKey: params.partitionKey,
        dcpSerialNumber: params.dcpSerialNumber,
    };
    yield put(getExportMessageArchiveAction(apiCallStatus.LOADING));
    try {
        const response = yield call(GatewayManagementApi.exportMessageArchive, payload);
        if (response?.referenceId) {
            yield put(getExportMessageArchiveAction(apiCallStatus.SUCCESS));
            notify(translate('ABB.Powertrain.Frontend.ExportMessageArchiveSuccessMessage'), NOTIFICATION_TYPES.SUCCESS);
        } else if (response?.error) {
            yield put(getExportMessageArchiveAction(apiCallStatus.ERROR));
            notify(response?.error?.message, NOTIFICATION_TYPES.ERROR, true);
        }
    } catch (error) {
        yield put(getExportMessageArchiveAction(apiCallStatus.ERROR, [], error));
        notify(error?.message, NOTIFICATION_TYPES.ERROR, true);
    }
}

export function* exportMessageArchiveWatchers() {
    yield takeLatest(EXPORT_MESSAGE_ARCHIVE_REQUEST, exportMessageArchiveSaga);
}
